import { render, staticRenderFns } from "./city-list-page.vue?vue&type=template&id=64e481df&scoped=true&"
import script from "./city-list-page.vue?vue&type=script&lang=js&"
export * from "./city-list-page.vue?vue&type=script&lang=js&"
import style0 from "./city-list-page.vue?vue&type=style&index=0&id=64e481df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e481df",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QDialog})
